export type KbSocialImportPlatform = "instagram" | "facebook"

export const KB_SOCIAL_IMPORT_DEFAULT_POSTS = 50
export const KB_INSTAGRAM_IMPORT_MAX_POSTS = 100
export const KB_FACEBOOK_IMPORT_MAX_POSTS = 50
export const KB_SOCIAL_IMPORT_MAX_POSTS = KB_INSTAGRAM_IMPORT_MAX_POSTS

export function getKbSocialImportMaxPosts(
  platform: KbSocialImportPlatform,
): number {
  switch (platform) {
    case "instagram":
      return KB_INSTAGRAM_IMPORT_MAX_POSTS
    case "facebook":
      return KB_FACEBOOK_IMPORT_MAX_POSTS
    default: {
      const exhaustivePlatform: never = platform
      return exhaustivePlatform
    }
  }
}
